module.exports = __webpack_public_path__ + "img/84d61583dfd3c75f82734bde02853e0b.png";